<template>
  <b-table
    v-if="!loading"
    :fields="columns"
    :items="items"
    class="table-model"
    sticky-header
    responsive
    head-variant="light"
    thead-class="align-middle"
    hover
  >
    <template #cell(index)="data">
      <b>{{ data.index + 1 }}</b>
    </template>
    <template #cell()="data">
      <template v-if="data.field.component">
        <component
          :is="data.field.component"
          v-bind="{ item: data.item }"
          v-on="data.field['componentListeners'] || {}"
        ></component>
      </template>
      <template v-else>{{ data.value }}</template>
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      items: []
    };
  },
  mounted() {
    this.fetchModels();
  },
  methods: {
    fetchModels() {
      this.loading = true;
      this.$axios
        .get(`/sale_orders`, {
          params: {
            with: "sales_invoice",
            remaining_receivable__gt: 0,
            customer_id__eq: this.value.id,
            with_sub_product: true
          }
        })
        .then(response => {
          const { data } = response.data;
          this.items = data.map(item => {
            return {
              ...item,
              day_past_due_age: this.$moment().diff(this.$moment(item.sales_invoice.due_date || item.ordered_at), "days")
            };
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    columns() {
      return [
        {
          key: "index",
          label: "No",
          tdClass: "align-middle",
          thStyle: {
            width: "1%"
          }
        },
        {
          key: "id",
          label: this.lodash.startCase("ID penjualan"),
          tdClass: "align-middle",
          thStyle: {
            // width: '1%',
          },
          component: {
            props: ["item"],
            template: `
              <router-link :to="{ name: 'sale_notes.show', params: { key: item.id } }">
                {{ item.id }}
              </router-link>
            `
          }
        },
        {
          key: "remaining_receivable",
          label: this.lodash.startCase("nominal piutang"),
          tdClass: "align-middle text-end",
          thStyle: {
            // width: "150px",
            textAlign: "right"
          },
          formatter: value => {
            return this.$numeral(value).format("$ 0,0");
          }
        },
        {
          key: "day_past_due_age",
          label: this.lodash.startCase("usia DPD"),
          tdClass: "align-middle text-center",
          thClass: "text-center",
          formatter: value => {
            return `${(value || 0)} hari`;
          }
        }
      ];
    }
  }
};
</script>
